import React, { PropsWithChildren } from 'react';

import { LoadingCard } from '@britishcouncil/react-solas-ors3';

import styled from '@emotion/styled';

import { useUserPermissions } from '@/utils/auth';
import ClientHydration from '@/app/ClientHydration';

import { TopHeader, AppFooter } from '../';

export const App = ({ children }: PropsWithChildren) => {
  const { isLoading } = useUserPermissions();

  return (
    <ClientHydration>
      {isLoading ? (
        <LoadingCard />
      ) : (
        <Root>
          <TopHeader />
          <StyledMain>{children}</StyledMain>
          <AppFooter />
        </Root>
      )}
    </ClientHydration>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StyledMain = styled.main`
  flex-grow: 1;
  width: 100%;
  max-width: var(--max-content-width);
  margin: 0 auto;
`;
